import script from "./BegrenzungRumpfjahr.vue?vue&type=script&setup=true&lang=js"
export * from "./BegrenzungRumpfjahr.vue?vue&type=script&setup=true&lang=js"

import "./BegrenzungRumpfjahr.vue?vue&type=style&index=0&id=57a3bc8a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57a3bc8a"]])

export default __exports__